import styles from './index.module.css';
import { dashboardDes } from '../../../language';
import clsx from 'clsx';
import { proficiencyLevelsDescription } from '../../../../../constants/proficiencyLevels';
import PropTypes from 'prop-types';
import React from 'react';

export const HexagonSkillView = ({
  name,
  skillLevel,
  grayLevel,
  isMyOwnGoal,
  isGoalCard = false
}) => {
  if (isMyOwnGoal) {
    return (
      <div
        className={clsx(styles.ownGoalView, {
          [styles.ownGoalViewGoalCard]: isGoalCard
        })}
      >
        <div className={styles.ownGoalViewContent}>
          {dashboardDes.myPlanCardDes.goalInformation.ownGoalViewContent}
        </div>
      </div>
    );
  }
  if (name) {
    return (
      <div
        className={clsx(styles.hexagonView, {
          [styles.hexagonViewGoalCard]: isGoalCard
        })}
      >
        <div
          className={clsx(styles.hexagonViewAfter, {
            [styles.hexagonViewAfterGoalCard]: isGoalCard
          })}
        />
        <div
          className={clsx(styles.hexagonContent, {
            [styles.hexagonContentGoalCard]: isGoalCard
          })}
        >
          <div className={styles.skillName}>{name}</div>
          {skillLevel > 0 && (
            <span
              className={clsx(
                styles.skillLevel,
                grayLevel && styles.grayBgColor
              )}
            >
              {proficiencyLevelsDescription[skillLevel - 1]}
            </span>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className={styles.unselectedHexagonView}>
      <div className={styles.unselectedHexagonViewAfter} />
      <div className={styles.unselectedMessage}>
        {dashboardDes.myPlanCardDes.goalInformation.unselectedMessage}
      </div>
    </div>
  );
};

HexagonSkillView.propTypes = {
  name: PropTypes.string,
  skillLevel: PropTypes.number,
  grayLevel: PropTypes.bool,
  isMyOwnGoal: PropTypes.bool,
  isGoalCard: PropTypes.bool
};
